var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33101 3.32083H10.1568V0.140833C9.84184 0.0975 8.75851 0 7.49684 0C4.86434 0 3.06101 1.65583 3.06101 4.69917V7.5H0.156006V11.055H3.06101V20H6.62267V11.0558H9.41017L9.85267 7.50083H6.62184V5.05167C6.62267 4.02417 6.89934 3.32083 8.33101 3.32083Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1bce60167473f21ef9927d72419003bb.svg";
export { ForwardRef as ReactComponent };